import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/lib/motion";
import { GALLERY } from "@/data/content";

const Gallery = () => {
  const [active, setActive] = useState(null);
  return (
    <div data-testid="gallery-page">
      <PageHero eyebrow="A Glimpse" title="Gallery"
        subtitle="Our professional set-up, premium equipment and the calm, relaxing environment we create — wherever you are." />

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [&>*]:mb-5">
          {GALLERY.map((g, i) => (
            <Reveal key={i} delay={(i % 3) * 0.05}>
              <button data-testid={`gallery-item-${i}`} onClick={() => setActive(g)}
                className="group relative w-full overflow-hidden rounded-2xl block">
                <img src={g.src} alt={g.label} loading="lazy" decoding="async" className="w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-primary/0 group-hover:bg-primary/40 transition-colors flex items-end p-5">
                  <span className="text-primary-foreground font-serif text-lg opacity-0 group-hover:opacity-100 transition-opacity">{g.label}</span>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </section>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-4xl p-0 overflow-hidden border-none bg-transparent">
          {active && (
            <div className="rounded-2xl overflow-hidden">
              <img src={active.src} alt={active.label} decoding="async" className="w-full max-h-[80vh] object-contain bg-primary" />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Gallery;
